<div class="public-banner">
  <div class="hero-banner-container">
    <div class="container">
      <div>
        <div class="heading">{{"LoginHeader.MainText" | translate}}</div>
        <div class="description">{{"LoginHeader.Description" | translate}}</div>
      </div>
    </div>
  </div>
  <div class="navbar-container">
    <div class="container">
      <div>
        <div class="togglermenu">
          <button [matMenuTriggerFor]="ctxNav" (menuOpened)="menuOpen=true" (menuClosed)="menuOpen=false">
            @if (!menuOpen) {
              <img alt="Menu" src="assets/images/menu.svg" />
            }
            @if (menuOpen) {
              <img alt="close" src="assets/images/icon-close.svg" />
            }
          </button>
        </div>
        <div class="navlinks">
          <nav>
            <ul>
              <li><a [routerLink]="getUrl('/safety-and-prevention/home')" [class.selected]="selected=='Home'"
                routerLinkActive="active-page"
              ariaCurrentWhenActive="page">{{'Tab.Home' | translate}}</a></li>
              <li><a [routerLink]="getUrl('/safety-and-prevention/cpo-approved-courses')" [class.selected]="selected=='CPOApprovedCourses'"
                routerLinkActive="active-page"
              ariaCurrentWhenActive="page">{{'Tab.CPOApprovedCourses' | translate}}</a></li>
              <li><a [routerLink]="getUrl('/safety-and-prevention/eligibility-checker')" [class.selected]="selected=='EligibilityChecker'"
                routerLinkActive="active-page"
              ariaCurrentWhenActive="page">{{'Tab.EligibilityChecker' | translate}}</a></li>
              <li><a [routerLink]="getUrl('/safety-and-prevention/approved-training-providers')" [class.selected]="selected=='ApprovedTrainingProviders'"
                routerLinkActive="active-page"
              ariaCurrentWhenActive="page">{{'Tab.ApprovedTrainingProviders' | translate}}</a></li>
            </ul>
          </nav>
        </div>
        <button class="login" (click)="goToLogin()">
          {{'LoginHeader.Login' | translate}}
          <img alt="" src="assets/images/lock-icon.svg" />
        </button>
      </div>
      <mat-menu #ctxNav="matMenu" xPosition="before" backdropClass="navbar-menu-backdrop">
        <a mat-menu-item [routerLink]="getUrl('/safety-and-prevention/home')">{{'Tab.Home' | translate}}</a>
        <a mat-menu-item [routerLink]="getUrl('/safety-and-prevention/cpo-approved-courses')">{{'Tab.CPOApprovedCourses' | translate}}</a>
        <a mat-menu-item [routerLink]="getUrl('/safety-and-prevention/eligibility-checker')">{{'Tab.EligibilityChecker' | translate}}</a>
        <a mat-menu-item [routerLink]="getUrl('/safety-and-prevention/approved-training-providers')">{{'Tab.ApprovedTrainingProviders' | translate}}</a>
      </mat-menu>
    </div>
  </div>
</div>

@if (pagepath!='') {
  <div class="page-path">
    <div class="container">
      <nav aria-label="breadcrumbs">
        <ul>
          <li><a [routerLink]="getUrl('/safety-and-prevention/home')" [class.selected]="selected=='Home'">{{'Tab.Home' | translate}}</a></li>
          <li><span aria-hidden="true">></span></li>
          <li><a aria-current='location' [routerLink]="router.url">{{'Tab.' + pagepath | translate}}</a></li>
        </ul>
      </nav>
    </div>
  </div>
}
